export interface IFrontPageBannerImage {
    id: string;
    link: string;
    image: string;
}

export class FrontPageBannerImage implements IFrontPageBannerImage {
    id: string;
    link: string;
    image: string;

    constructor();
    constructor(obj: IFrontPageBannerImage);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.link = obj && obj.link || "";
        this.image = obj && obj.image || "";
    }
}